import React, { useState } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { COLUMN_USER, ROLE_USER } from "../utils/constDispatch";
import { API_DelUser, API_EditUser, API_ResetPassword } from "../utils/http";

const btnSx = {
  borderRadius: "20px",
  textTransform: "none",
  fontWeight: 500,
  fontSize: 13,
};

export default function ListUser({ user_arr, get_user }) {
  const [selected_id, set_selected_id] = useState(null);
  const [rowSelection, setRowSelection] = useState([]);
  const [row_click, set_row_click] = useState(null);

  const [new_user_arr, set_new_user_arr] = useState(user_arr);

  const DeleteUser = (username) => {
    API_DelUser(username, (data) => {
      if (data.success) {
        get_user();
      }
    });
  };

  const ResetUser = (username) => {
    API_ResetPassword(username, (data) => {
      if (data.success) {
        get_user();
      }
    });
  };

  const ChangeRoleUser = (role) => {
    let body = {
      data: {
        role: role,
      },
      _id: row_click._id,
    };

    API_EditUser(body, (data) => {
      if (data.success) {
        get_user();
      }
    });
  };

  const ChangeCreatedBy = () => {
    let body = {
      data: {
        pdf_created_by: pdf_created_by,
      },
      _id: row_click._id,
    };

    API_EditUser(body, (data) => {
      if (data.success) {
        get_user();
        setOpenModal(false);
      }
    });
  };

  const [openModal, setOpenModal] = useState(false);
  const [pdf_created_by, setPdfCreatedBy] = useState("");

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {row_click != null && (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            mb: 1.5,
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="outlined"
            size="small"
            sx={btnSx}
            onClick={() => ResetUser(row_click.username)}
          >
            Reset Password
          </Button>
          <Button
            variant="outlined"
            size="small"
            sx={btnSx}
            onClick={() => ChangeRoleUser(ROLE_USER.ADMIN)}
          >
            Make Admin
          </Button>
          <Button
            variant="outlined"
            size="small"
            sx={btnSx}
            onClick={() => ChangeRoleUser(ROLE_USER.OPERATOR)}
          >
            Make Operator
          </Button>
          <Button
            variant="outlined"
            size="small"
            sx={btnSx}
            onClick={() => ChangeRoleUser(ROLE_USER.EDITER)}
          >
            Make User
          </Button>
        </Box>
      )}

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            fontSize: 17,
            borderBottom: "1px solid #E0E0E0",
            backgroundColor: "#F5F7FA",
            py: 1.5,
            px: 3,
          }}
        >
          Edit User
        </DialogTitle>
        <DialogContent sx={{ pt: "16px !important" }}>
          <TextField
            size="small"
            label="Created By"
            value={pdf_created_by}
            onChange={(e) => setPdfCreatedBy(e.target.value)}
            sx={{
              mt: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                fontSize: 13,
              },
              "& .MuiInputLabel-root": {
                fontSize: 13,
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            size="small"
            sx={btnSx}
            onClick={() => setOpenModal(false)}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            disableElevation
            sx={btnSx}
            onClick={() => ChangeCreatedBy()}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {new_user_arr.length === 0 ? null : (
        <Box
          sx={{
            "& .MuiDataGrid-root": {
              border: "1px solid #E0E0E0",
              borderRadius: "10px",
              overflow: "hidden",
              fontSize: 13,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#F5F7FA",
              fontSize: 13,
              fontWeight: 600,
              color: "#555",
              borderBottom: "1px solid #E0E0E0",
            },
            "& .MuiDataGrid-row": {
              "&:hover": {
                backgroundColor: "#F8FBFF",
              },
              "&.Mui-selected": {
                backgroundColor: "#EBF4FF",
                "&:hover": {
                  backgroundColor: "#DDEEFF",
                },
              },
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "1px solid #F0F0F0",
              py: 1,
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid #E0E0E0",
              backgroundColor: "#FAFAFA",
            },
          }}
        >
          <DataGrid
            getRowId={(item) => item._id}
            rows={user_arr}
            columns={COLUMN_USER}
            pageSizeOptions={[5, 10, 20]}
            rowSelectionModel={rowSelection}
            onRowSelectionModelChange={(e) => {
              setRowSelection(e);
              set_selected_id(e[0]);
              set_row_click(user_arr.find((x) => x._id === e[0]));
              setOpenModal(true);
              setPdfCreatedBy(
                user_arr.find((x) => x._id === e[0]).pdf_created_by
              );
            }}
            disableMultipleRowSelection={true}
          />
        </Box>
      )}
    </Box>
  );
}
